'use client';
import type { ReactElement } from 'react';
import { ArrowLeft } from 'lucide-react';
import Link from 'next/link';
import Image from 'next/image';
import { useParams, usePathname } from 'next/navigation';
import logo from '@/assets/icons/logo.png';
import black_logo from '@/assets/icons/black-logo.png';
import TagBar from './components/tagbar';
import SearchBar from './components/search';
import FilterButton from './components/filterbutton';
import TgVector from '@/components/ui/svg/contacts/tgvector';
import { useBackNavigation } from '@/app/hooks/useBackNavigation';
// import { useScrollRestoration } from '@/app/hooks/useScrollRestoration';

export default function Header(): ReactElement {
  // useScrollRestoration();
  const { section } = useParams();
  const { goBack } = useBackNavigation();
  const sectionValue = Array.isArray(section) ? section[0] : section;
  const pathname = usePathname();
  console.log('pathname', pathname);
  const isNotHomePage = ![
    '/',
    '/catalog',
    '/contacts',
    '/account',
    '/privacy-policy',
  ].includes(pathname);
  const isNotConAccPage = !['/contacts', '/account'].includes(pathname);
  if (pathname === '/cart' || pathname === '/favorites') {
    return <></>;
  }
  return (
    <div
      className={` ${isNotHomePage && !pathname.includes('/order/') && !pathname.includes('/all') ? `bg-${sectionValue}-based text-${sectionValue}-text` : 'bg-red-regular text-white'} w-full px-4`}
    >
      <header
        className={`fixed left-0 z-[1000] flex w-full max-w-full items-center justify-between px-4 py-3.5 pt-4 ${isNotHomePage && !pathname.includes('/order/') && !pathname.includes('/all') ? `bg-${sectionValue}-based` : 'bg-red-regular'}`}
      >
        {isNotHomePage && (
          <button onClick={goBack} className="w-auto px-0 py-0">
            <ArrowLeft width={24} height={24} strokeWidth="2" />
          </button>
        )}
        <Link href="/">
          <Image
            src={
              section === 'home' || section === 'children' ? black_logo : logo
            }
            alt="Logo"
            width={185}
            height={32}
            priority
            quality={100}
            className="h-full w-full max-w-[185px]"
          />
        </Link>
        <Link
          href="https://t.me/fashionist_com"
          // href="/images"
          // href="/#"
          className={`flex items-center gap-1 rounded-full p-2.5 ${sectionValue ? `bg-${sectionValue}-light` : 'bg-red-light'}`}
        >
          <TgVector
            width={24}
            height={24}
            strokeWidth="1"
            fill="none"
            stroke={
              sectionValue === 'woman' ||
              sectionValue === 'child' ||
              !sectionValue
                ? '#fff'
                : '#000'
            }
          />
          <p className="text-xs">Консьерж сервис</p>
        </Link>
      </header>
      {isNotConAccPage && !pathname.includes('/order/') && <SearchBar />}
      {(sectionValue || pathname.includes('/all')) && <FilterButton />}
      <TagBar />
    </div>
  );
}
